<script>
  import Header1 from './blocks/header1.svelte'
  import Header2 from './blocks/header2.svelte'
  import Header3 from './blocks/header3.svelte'
  import Slogan from './blocks/slogan.svelte'
  import TextImage from './blocks/text-image.svelte'
  import TextLargeImage from './blocks/text-large-image.svelte'
  import ImageBanner from './blocks/image-banner.svelte'
  import LongRead from './blocks/long-read.svelte'
  import Gallery from './blocks/gallery.svelte'
  import TextVideo from './blocks/text-video.svelte'
  import VideoBanner from './blocks/video-banner.svelte'
  import ImageCarousel from './blocks/image-carousel.svelte'

  export let data
  export let currentId
  export let showEdit
  export let blocksConfig
  export let editMode

  let base = data.base

  blocksConfig.categories = ['headers', 'text', 'images', 'video']
  blocksConfig.blocks = [
    {
      name: 'header1',
      cat: 'headers',
      fields: 'title,tagline,image,images',
    },
    { name: 'header2', cat: 'headers', fields: 'title,tagline' },
    { name: 'header3', cat: 'headers', fields: 'title,tagline,image,images' },
    { name: 'slogan', cat: 'text', fields: 'title,body' },
    { name: 'long-read', cat: 'text', fields: 'title,body,extended' },
    {
      name: 'text-image',
      cat: 'images',
      fields: 'title,body,image,images,flip',
    },
    {
      name: 'text-large-image',
      cat: 'images',
      fields: 'title,body,image,images,flip',
    },
    {
      name: 'image-banner',
      cat: 'images',
      fields: 'title,image,images',
    },
    { name: 'text-video', cat: 'video', fields: 'title,body,video,flip' },
    { name: 'video-banner', cat: 'video', fields: 'video' },
    { name: 'gallery', cat: 'galleries', fields: 'title,body,images' },
    { name: 'image-carousel', cat: 'galleries', fields: 'title,body,images' },
  ]

  function openEditor(id) {
    currentId = id
    currentId = currentId
    if (document.getElementsByClassName('active-item').length) {
      document.querySelector('.active-item').classList.remove('active-item')
    }
    document.querySelector('#item-' + currentId).classList.add('active-item')
    showEdit = true
  }

  /*
  function editHeader() {
    currentId = 'header'
    currentId = currentId
    if (document.getElementsByClassName('active-item').length) {
      document.querySelector('.active-item').classList.remove('active-item')
    }
    document.querySelector('#header').classList.add('active-item')
    showEdit = true
  }
  */
</script>

<header>

  {#each data.entries as item}
    {#if item.layout == 'header1'}
      <section id="item-{item.id}" class={item.color}>
        {#if editMode}
          <img
            src="assets/img/cog.png"
            alt="edit"
            class="editbtn"
            on:click={() => openEditor(item.id)} />
        {/if}
        <Header1 bind:item bind:base />
      </section>
    {/if}

    {#if item.layout == 'header2'}
      <section id="item-{item.id}" class={item.color}>
        {#if editMode}
          <img
            src="assets/img/cog.png"
            alt="edit"
            class="editbtn"
            on:click={() => openEditor(item.id)} />
        {/if}
        <Header2 bind:item bind:base />
      </section>
    {/if}

    {#if item.layout == 'header3'}
      <section id="item-{item.id}" class={item.color}>
        {#if editMode}
          <img
            src="assets/img/cog.png"
            alt="edit"
            class="editbtn"
            on:click={() => openEditor(item.id)} />
        {/if}
        <Header3 bind:item bind:base />
      </section>
    {/if}
  {/each}

</header>

{#if data.entries.length}
  <main>
    {#each data.entries as item}
      {#if item.layout == 'slogan'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <Slogan bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'text-image'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <TextImage bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'text-large-image'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <TextLargeImage bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'image-banner'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <ImageBanner bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'long-read'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <LongRead bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'gallery'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <Gallery bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'text-video'}
        <section id="item-{item.id}" class={item.color}>
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <TextVideo bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'video-banner'}
        <section id="item-{item.id}" class="sf-video-banner {item.color}">
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <VideoBanner bind:item bind:base />
        </section>
      {/if}
      {#if item.layout == 'image-carousel'}
        <section id="item-{item.id}" class="sf-image-carousel {item.color}">
          {#if editMode}
            <img
              src="assets/img/cog.png"
              alt="edit"
              class="editbtn"
              on:click={() => openEditor(item.id)} />
          {/if}
          <ImageCarousel bind:item bind:base />
        </section>
      {/if}
    {/each}
  </main>
{:else}
  <div class="text-center empty-wrap">
    <img
      src="assets/img/empty.png"
      alt="add some blocks"
      class="img-fluid empty" />
  </div>
{/if}
